import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Main from "pages/Main";
import DeliverNew from "pages/DeliverNew";
import Deliveries from "pages/Deliveries";
import UserInformationPage from "pages/UserInformation";
import Setup from "pages/Setup";
import Campaigns from "pages/Campaigns";
import { getActiveUser } from "store/selectors";
import { useSelector } from "react-redux";
import { ApprovalsPageAdmin, ApprovalsPageContributor } from "pages/Approvals";
import HealthCheck from "./HealthCheck/HealthCheck";

function Routes() {
  const user = useSelector(getActiveUser);
  const isLoggedIn = !!user.item;
  const isAdmin = isLoggedIn && user.item.isAdmin;
  const isPowerAdmin = isLoggedIn && user.item.isPowerAdmin;
  const isSuperAdmin = isLoggedIn && user.item.isSuperAdmin;

  return (
    <Switch>
      <Route exact path="/" component={isLoggedIn ? Main : <Redirect to="/" />} />
      <Route exact path="/deliverNew" component={DeliverNew} />
      <Route path="/deliveries" component={Deliveries} />
      <Route path="/campaigns" component={(isAdmin || isSuperAdmin || isPowerAdmin) && Campaigns} />
      <Route exact path="/user-data" component={UserInformationPage} />
      <Route path="/setup" component={isSuperAdmin ? Setup : () => <Redirect to="/" />} />
      <Route
        path="/approvals"
        component={
          isAdmin || isSuperAdmin || isPowerAdmin ? ApprovalsPageAdmin : ApprovalsPageContributor
        }
      />
      <Route exact path="/health-check" component={HealthCheck} />
      <Redirect to="/" />
    </Switch>
  );
}

export default Routes;
